// Common utility functions used across multiple modules

import "jquery-mask-plugin";
// Loading button functionality
export function setLoadingState(element, loadingText) {
    if (element instanceof jQuery) {
        element = element[0];
    }
    element.setAttribute("data-original-text", element.innerHTML);
    element.setAttribute("disabled", "disabled");
    // Remove aspas duplas do texto se existirem
    const cleanText = (loadingText || "Aguarde...").replace(/"/g, "");
    element.innerHTML = `<i class="sg sg-spinner-gap animate-spin"></i> ${cleanText}`;
}

export function resetButtonState(element) {
    if (element instanceof jQuery) {
        element = element[0];
    }
    const originalText = element.getAttribute("data-original-text");
    element.removeAttribute("disabled");
    element.innerHTML = originalText;
}

// Import new modal component
import { createModal as createNewModal } from "../shared/components/modal.js";

// Updated createModal function using new component
export function createModal(titulo, conteudo) {
    return createNewModal(titulo, conteudo);
}

// Mask application utility
export function aplicarMascaras() {
    if (typeof $.fn.mask !== "function") {
        if (
            window.jQuery &&
            window.jQuery.fn &&
            typeof window.jQuery.fn.mask === "function"
        ) {
            $.fn.mask = window.jQuery.fn.mask;
        }
    }
    $(".cpfMask").mask("000.000.000-00");
    $(".cnpjMask").mask("00.000.000/0000-00");
    $(".cepMask").mask("00000-000");
    $(".phoneMask").mask("(00) 00000-0000");

    // Máscaras de telefone específicas
    $(".telFixoMask").mask("(00) 0000-0000", {
        placeholder: "(00) 0000-0000",
    });
    $(".telCelMask").mask("(00) 00000-0000", {
        placeholder: "(00) 00000-0000",
    });

    $(".valorMask").mask("#.##0,00", { reverse: true });
    $(".percentMask").mask("##0,00%", { reverse: true });
    $(".dateMask").mask("00/00/0000");
    $(".timeMask").mask("00:00");
    $(".kmMask").mask("#.##0", { reverse: true });

    // Máscara de placa removida - deixar o MasksValidator gerenciar
    // $(".plate-mask, .placaMask").mask("AAA-0000", {
    //     placeholder: "ABC-1234",
    //     translation: {
    //         'A': {pattern: /[A-Za-z]/},
    //         '0': {pattern: /[0-9]/}
    //     }
    // });
}

// Delegated mask binding on focus and real-time validation
export function initMaskHandlers() {
    if (typeof $.fn.mask !== "function") {
        if (
            window.jQuery &&
            window.jQuery.fn &&
            typeof window.jQuery.fn.mask === "function"
        ) {
            $.fn.mask = window.jQuery.fn.mask;
        }
    }
    const applyMaskFor = function (el) {
        const $el = $(el);
        if ($el.hasClass("cpfMask")) $el.mask("000.000.000-00");
        if ($el.hasClass("cnpjMask")) $el.mask("00.000.000/0000-00");
        if ($el.hasClass("cepMask")) $el.mask("00000-000");
        if ($el.hasClass("telFixoMask")) $el.mask("(00) 0000-0000");
        if ($el.hasClass("telCelMask")) $el.mask("(00) 00000-0000");
        if ($el.hasClass("dateMask")) $el.mask("00/00/0000");
        if ($el.hasClass("timeMask")) $el.mask("00:00");
    };

    const setInputMode = function (el) {
        const $el = $(el);
        if (
            $el.hasClass("cpfMask") ||
            $el.hasClass("cnpjMask") ||
            $el.hasClass("cepMask")
        ) {
            $el.attr("inputmode", "numeric");
        }
        if ($el.hasClass("telFixoMask") || $el.hasClass("telCelMask")) {
            $el.attr("inputmode", "tel");
        }
    };

    $(document).on(
        "focusin",
        ".cpfMask, .cnpjMask, .cepMask, .telFixoMask, .telCelMask, .dateMask, .timeMask",
        function () {
            applyMaskFor(this);
            setInputMode(this);
        },
    );

    const validateMasked = function (el) {
        const $el = $(el);
        const raw = ($el.val() || "").replace(/\D+/g, "");
        let expectedLen = null;
        if ($el.hasClass("cpfMask")) expectedLen = 11;
        if ($el.hasClass("cnpjMask")) expectedLen = 14;
        if ($el.hasClass("cepMask")) expectedLen = 8;
        if ($el.hasClass("telFixoMask")) expectedLen = 10;
        if ($el.hasClass("telCelMask")) expectedLen = 11;

        const isOptional = !$el.prop("required");
        const isEmpty = raw.length === 0;
        if (expectedLen) {
            const valid = isEmpty ? isOptional : raw.length === expectedLen;
            if (!valid) {
                $el.addClass("is-invalid")[0]?.setCustomValidity("");
            } else {
                $el.removeClass("is-invalid")[0]?.setCustomValidity("");
            }
        }
    };

    $(document).on(
        "input blur",
        ".cpfMask, .cnpjMask, .cepMask, .telFixoMask, .telCelMask",
        function () {
            validateMasked(this);
        },
    );
}

// Sanitize masked fields before submit
export function sanitizeMaskedFields($form) {
    const sanitizeByName = function (name) {
        const $f = $form.find(`[name="${name}"]`);
        if ($f.length) {
            const val = ($f.val() || "").toString();
            $f.val(val.replace(/\D+/g, ""));
        }
    };
    // Clientes PF/PJ
    sanitizeByName("cpfCliente");
    sanitizeByName("cnpjCliente");
    sanitizeByName("celCliente");
    sanitizeByName("telCliente");
    sanitizeByName("cepCliente");
    // Datas: manter formato do navegador se type=date; se texto, remover não-dígitos
    const $date = $form.find('[name="dataNascCliente"]');
    if ($date.length && ($date.attr("type") || "").toLowerCase() !== "date") {
        const v = ($date.val() || "").toString();
        $date.val(v.replace(/[^\d\/]/g, ""));
    }
}

// Attach to window for modules that call via window.*
if (typeof window !== "undefined") {
    window.aplicarMascaras = aplicarMascaras;
    window.initMaskHandlers = initMaskHandlers;
    window.sanitizeMaskedFields = sanitizeMaskedFields;
    window.buscarEnderecoPorCep = buscarEnderecoPorCep;
    window.lookupAddressByCep = buscarEnderecoPorCep;
}

// Value formatting utility
export function formataValorMonetario(valor) {
    if (!valor) return "0,00";

    // Remove caracteres não numéricos exceto vírgula e ponto
    let valorLimpo = valor.toString().replace(/[^\d,.-]/g, "");

    // Converte para número
    let numero = parseFloat(valorLimpo.replace(",", "."));

    if (isNaN(numero)) return "0,00";

    // Formata com 2 casas decimais e vírgula como separador decimal
    return numero.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}

// Address lookup by CEP
export function buscarEnderecoPorCep(cep, tipoCliente = "") {
    if (cep.length === 9) {
        cep = cep.replace(/[-]/g, "");

        return $.ajax({
            url: "/api/endereco",
            type: "POST",
            data: { cep: cep },
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
        });
    }
    return Promise.reject("CEP inválido");
}

// CNPJ lookup
export function buscarDadosCnpj(cnpj) {
    if (cnpj.length === 18) {
        cnpj = cnpj.replace(/[.\/-]/g, "");

        return $.ajax({
            url: "/api/cnpj",
            type: "POST",
            data: { cnpj: cnpj },
        });
    }
    return Promise.reject("CNPJ inválido");
}

// Import new pagination component
import { setupQuickPagination } from "../shared/components/pagination.js";

// Generic search with pagination (updated to use new component)
export function setupInfiniteScroll(
    container,
    loadUrl,
    pageInput = null,
    extraConfig = {},
) {
    // Mescla configurações garantindo que getParams e outros callbacks sejam preservados
    const config = {
        container,
        loadUrl,
        pageInput,
        ...extraConfig,
    };
    return setupQuickPagination(container, loadUrl, null, null, config);
}

// Generic search functionality
export function setupSearch(
    searchInputId,
    searchUrl,
    tableSelector,
    tbodySelector,
    getExtraData = null,
) {
    // Listen for custom refresh event
    $(document).on("search:refresh", function () {
        const value = $(searchInputId).val();
        performSearch(value);
    });

    $(searchInputId).on("keyup", function () {
        const value = $(this).val();
        $(".textNoData").hide();
        $(".dataNotFound").hide();

        if (value.length >= 3) {
            $("body").addClass("loaded-search");
            performSearch(value);
        }

        if (value.length === 0) {
            $("body").removeClass("loaded-search");
            performSearch("");
        }
    });

    function performSearch(searchValue) {
        let data = { value: searchValue };

        // Add extra data if callback is provided
        if (getExtraData && typeof getExtraData === "function") {
            const extraData = getExtraData();
            if (extraData) {
                data = { ...data, ...extraData };
            }
        }

        $.ajax({
            url: searchUrl,
            type: "POST",
            data: data,
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            beforeSend: function () {
                $(tableSelector).hide();
                $(".loadingSearch").show();
            },
            success: function (response) {
                if (response.html && response.html.trim() !== "") {
                    $(".dataNotFound").hide();
                    $(tbodySelector).empty().append(response.html).show();
                    $(tableSelector).removeClass("d-none").show();
                    $(".loadingSearch").hide();

                    if (typeof response.count !== "undefined") {
                        const $countLabel = $("#listing-count");
                        if ($countLabel.length) {
                            const $tbody = $(tbodySelector);
                            const currentCount =
                                $tbody.find("tr").length || response.count;
                            const currentText = $countLabel.text();
                            const regex = /Exibindo\s+(\d+)\s+de\s+(\d+)/;

                            // Atualiza o total base se vier na resposta (prioridade para total filtrado)
                            let baseTotal = undefined;
                            if (typeof response.total !== "undefined") {
                                baseTotal = response.total;
                                $countLabel.data("totalAllBase", baseTotal);
                            } else if (
                                typeof response.totalAll !== "undefined"
                            ) {
                                baseTotal = response.totalAll;
                                $countLabel.data("totalAllBase", baseTotal);
                            }

                            // Fallback para o valor salvo ou extraído do texto
                            if (typeof baseTotal === "undefined") {
                                baseTotal = $countLabel.data("totalAllBase");
                                if (!baseTotal && regex.test(currentText)) {
                                    const match = currentText.match(regex);
                                    if (match && match[2]) {
                                        baseTotal = parseInt(match[2], 10) || 0;
                                        $countLabel.data(
                                            "totalAllBase",
                                            baseTotal,
                                        );
                                    }
                                }
                            }

                            const totalBase =
                                baseTotal || response.total || currentCount;

                            if (regex.test(currentText)) {
                                const newText = currentText.replace(
                                    /Exibindo\s+\d+\s+de\s+\d+/,
                                    `Exibindo ${currentCount} de ${totalBase}`,
                                );
                                $countLabel.text(newText);
                            } else {
                                $countLabel.text(
                                    `Exibindo ${currentCount} de ${totalBase} registros`,
                                );
                            }
                        }
                    }

                    // Trigger reset event if search is cleared
                    if (searchValue === "") {
                        $(document).trigger("listing:reset", [response]);
                    }

                    // Trigger generic success event
                    $(document).trigger("search:success", [response, data]);
                } else {
                    $(".loadingSearch").hide();
                    $(".dataNotFound").show();

                    // Trigger generic success event even if no data found (to update metrics etc)
                    $(document).trigger("search:success", [response, data]);
                }
            },
            error: function (xhr, status, error) {},
        });
    }
}

// Export aliases for compatibility with English function names
export { resetButtonState as resetLoadingState };
export { aplicarMascaras as applyMasks };
// initMaskHandlers is already exported as a named function above
export { buscarEnderecoPorCep as lookupAddressByCep };
export { buscarDadosCnpj as lookupDataByCnpj };
export { setupSearch as setupGenericSearch };
